import { memoize } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { createRoot } from 'react-dom/client';
import { Menu } from './components/menu/Menu';
import profile from './profile';

export const getGlobalForceMenuOpenById$ = memoize(
    () => new BehaviorSubject<string | undefined>(undefined)
);

interface MenuModuleArgs {
    options: {
        elementId: string;
    };
}

export function menuModule({ options: { elementId } }: MenuModuleArgs): void {
    const forceMenuOpenById$ = getGlobalForceMenuOpenById$();
    const container = document.getElementById(elementId);

    if (!container) {
        throw new Error(`Element with id ${elementId} not found`);
    }

    createRoot(container).render(
        <Menu
            profile={profile}
            forceMenuOpenById$={forceMenuOpenById$}
            location={window.location}
            replaceLocation={window.location.replace.bind(window.location)}
        />
    );
}
